export default __webpack_public_path__ + "static/media/Jump (2).40515b3c.png";